import { render } from "./InvoicesList.vue?vue&type=template&id=a79f7bc8&scoped=true&ts=true"
import script from "./InvoicesList.vue?vue&type=script&lang=ts"
export * from "./InvoicesList.vue?vue&type=script&lang=ts"

import "./InvoicesList.vue?vue&type=style&index=0&id=a79f7bc8&scoped=true&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79f7bc8"]])

export default __exports__